import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import { Helmet } from 'react-helmet';
import "./BlogPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import Carousel from "./bcarousel";
import {HashLink as Link} from "react-router-hash-link";
import BlogCardImage from "../../Common/BlogCards"

//import {Link} from "react-router-dom";

function App() {
  return (
    <div className="bpd-container-center-horizontal">
      <Helmet>
        <title>Webuildd Construction | Blogs</title>
        <meta name="keywords" content="House construction blogs, commercial construction blogs, Home building blogs, construction blogs, construction blogs India, construction company blogs, latest construction blogs" />
        <meta name="description" content="Webuildd construction from Bangalore specializes in residential and commercial construction and offers interior design services with highest quality and transparency." />
      </Helmet>
      <div className="bpd-x08-blogs-page-desktop">
        <div className="bpd-overlap-group">
          <div className="bpd-frame-1576">
            <div className="bpd-overlap-group1-4">
              <h1 className="bpd-title bpd-valign-text-middle bpd-typographyheadlineh2-extrabold-40">Blogs</h1>
              <div className="bpd-group-182">
                  <Carousel/>
              </div>
              {/* <img
                className="bpd-group-182"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d5732641e2212c658d387b/img/group-182@2x.jpg"
              /> */}
              {/* <div className="bpd-group-129">
                <div className="bpd-overlap-group2">
                  <div className="bpd-ellipse-101"></div>
                </div>
                <div className="bpd-ellipse-100"></div>
                <div className="bpd-ellipse-10"></div>
                <div className="bpd-ellipse-10"></div>
                <div className="bpd-ellipse-10"></div>
              </div> */}
              {/* <div className="bpd-frame-1568">
                  {
                    BlogCards.map(item =>(
                      <div className={`bpd-${item.divClass}`}>
                        {
                          item.divData.map(itemdata =>
                            (
                              <BlogCard
                                blogThumbnail={itemdata.blogThumbnail}
                                address={itemdata.address}
                                text1={itemdata.text1}
                                text2={itemdata.text3}
                                className={itemdata.className}
                                frame1587Props={itemdata.frame1587Props}
                              /> 
                            ))
                        }
                      </div>
                    ))
                  } */}
                  <div className="bpd-frame-1568">
                    <BlogCardImage />
                  {/* </div> */}
                  <Button22>VIEW MORE</Button22>
                  </div>
                  
                {/* <div className="bpd-frame-1640"> */}
                  {/* <BlogCard
                    blogThumbnail="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-9@2x.png"
                    address="5 June 2021"
                    text1="Lorem Ipsum passages of Lorem Ipsum available"
                    text2="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…"
                    frame1587Props={blogCardData.frame1587Props}
                  /> */}
                  {/* <BlogCard
                    blogThumbnail="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-12@2x.png"
                    address="5 June 2021"
                    text1="Lorem Ipsum passages of Lorem Ipsum available"
                    text2="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…"
                    className="bpd-blog-card-1-1"
                    frame1587Props={blogCard2Data.frame1587Props}
                  />
                  <BlogCard
                    blogThumbnail="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-15@2x.png"
                    address="5 June 2021"
                    text1="Lorem Ipsum passages of Lorem Ipsum available"
                    text2="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…"
                    className="bpd-blog-card-1"
                    frame1587Props={blogCard3Data.frame1587Props}
                  /> */}
                {/* </div> */}
                {/* <Frame1641
                  blogCardProps={frame1641Data.blogCardProps}
                  blogCard2Props={frame1641Data.blogCard2Props}
                  blogCard3Props={frame1641Data.blogCard3Props}
                />
                <Frame1641
                  blogCardProps={frame16412Data.blogCardProps}
                  blogCard2Props={frame16412Data.blogCard2Props}
                  blogCard3Props={frame16412Data.blogCard3Props}
                /> */}
                
              {/* </div> */}
              <p className="bpd-text-28 bpd-typographybody16-regular">
                There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy
                alteration in that an some form by the injected humour or randomised words which don’t look even that
                slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing.
                There are many variations passages of Lorem as Ipsums available but the majority have suffered that
                alterations in that some form by injected humour or randomised words which don’t looks even slightly
                that believable. If you are Lorem as Ipsum&nbsp;&nbsp;you need to be sure there isn’t anything as
                embarrassing. There are many variation of passages Lorem Ipsum available but the majority have suffered
                that a aalteration in that some form by injected humour or randomised words which don’t look even
                slightly the believable.
              </p>
              {/* <div className="bpd-group-89"> */}
                {/* <img
                  className="bpd-line-4"
                  src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4@1x.svg"
                />
                <img
                  className="bpd-line"
                  src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-5@1x.svg"
                />
                <div className="bpd-biarrow-right-short">
                  <img
                    className="bpd-vector-8"
                    src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-183@2x.svg"
                  />
                </div>
                <img
                  className="bpd-line-6"
                  src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-5@1x.svg"
                />
                <img
                  className="bpd-line"
                  src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-5@1x.svg"
                />
                <img
                  className="bpd-line-8"
                  src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-4@1x.svg"
                /> */}
              {/* </div> */}
            </div>
          </div>
          {/* <HeaderWithBackground22 {...headerWithBackground22Data} /> */}
          <NavBar />
        </div>
        <Footer />
        {/* <Footer32
          group32Props={footer32Data.group32Props}
          frame5Props={footer32Data.frame5Props}
          frame6Props={footer32Data.frame6Props}
          frame7Props={footer32Data.frame7Props}
        /> */}
      </div>
    </div>
  );
}

export default App;

function BlogCard(props) {
  const { blogThumbnail, address, text1, text2, className, frame1587Props } = props;

  console.log(className);
  return (
    <div className={`bpd-blog-card-2 bpd-${className || ""}`}>
      <div className="bpd-blog-thumbnail" style={{ backgroundImage: `url(${blogThumbnail})` }}></div>
      <div className="bpd-address bpd-valign-text-middle bpd-overpass-semi-bold-scarpa-flow-16px">{address}</div>
      <div className="bpd-text bpd-valign-text-middle bpd-overpass-bold-shark-24px">{text1}</div>
      <p className="bpd-text-1 bpd-overpass-semi-bold-scarpa-flow-16px">{text2}</p>
      <Frame1587 text3={frame1587Props.text3} url={frame1587Props.url} plusProps={frame1587Props.plusProps} />
    </div>
  );
}


function Frame1587(props) {
  const { text3, plusProps,url } = props;

  return (
    
    <div className="bpd-frame-1587">
      <Link to={`${url}`}>
      <div className="bpd-text-2 bpd-valign-text-middle bpd-typographybodycaption-14-semi-bold">{text3}</div></Link>
      <Plus src={plusProps.src} />
    </div>
  );
}


function Plus(props) {
  const { src } = props;

  return (
    <div className="bpd-arrowsarrow-right">
      <img className="bpd-vector" src={src} />
    </div>
  );
}


function Frame1641(props) {
  const { blogCardProps, blogCard2Props, blogCard3Props } = props;

  return (
    <div className="bpd-frame-164">
      {/* <BlogCard
        blogThumbnail={Blogs.BlogCard1}
        address={blogCardProps.address}
        text1={blogCardProps.text1}
        text2={blogCardProps.text2}
        className={blogCardProps.className}
        frame1587Props={blogCardProps.frame1587Props}
      />
      <BlogCard
        blogThumbnail={blogCard2Props.blogThumbnail}
        address={blogCard2Props.address}
        text1={blogCard2Props.text1}
        text2={blogCard2Props.text2}
        className={blogCard2Props.className}
        frame1587Props={blogCard2Props.frame1587Props}
      />
      <BlogCard
        blogThumbnail={blogCard3Props.blogThumbnail}
        address={blogCard3Props.address}
        text1={blogCard3Props.text1}
        text2={blogCard3Props.text2}
        className={blogCard3Props.className}
        frame1587Props={blogCard3Props.frame1587Props}
      /> */}
    </div>
  );
}


function Button22(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x27326489TimelineData);
  }, []);

  return (
    <div className="bpd-x27326489 bpd-component bpd-component-wrapper not-ready">
      <div className="bpd-master-button-23Qqkb">
        <div className="bpd-button-i2732648951-ZtIG9d bpd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x27326489TimelineData = [
  {
    initial_state_name: "Property-1=Tertiary",
    root_element: ".bpd-x27326489",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function HeaderWithBackground22(props) {
//   const {
//     unselectedI2601273,
//     unselectedI26012732,
//     unselectedI26012733,
//     unselectedI26012734,
//     unselectedI26012735,
//     text127,
//     unselectedI26012736,
//     unselectedI26012737,
//     group86Props,
//     getAQuoteButton22Props,
//   } = props;

//   return (
//     <div className="bpd-header-with-background">
//       <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
//       <div className="bpd-frame-34">
//         <div className="bpd-frame-27">
//           <Link to="/">
//           <div className="bpd-unselected-i2601273 bpd-valign-text-middle bpd-typography-body-smalltext-14-regular">
//             {unselectedI2601273}
//           </div>
//           </Link>
//           <Link to="/about">
//           <div className="bpd-unselected-i2601273-1 bpd-valign-text-middle bpd-typography-body-smalltext-14-regular">
//             {unselectedI26012732}
//           </div>
//           </Link>
//           <Link to="/project">
//           <div className="bpd-unselected-i2601273-2 bpd-valign-text-middle bpd-typography-body-smalltext-14-regular">
//             {unselectedI26012733}
//           </div>
//           </Link>
//           <Link to="/video">
//           <div className="bpd-unselected-i2601273-3 bpd-valign-text-middle bpd-typography-body-smalltext-14-regular">
//             {unselectedI26012734}
//           </div>
//           </Link>
//           <Link to="/insight">
//           <div className="bpd-unselected-i2601273-4 bpd-valign-text-middle bpd-typography-body-smalltext-14-regular">
//             {unselectedI26012735}
//           </div>
//           </Link>
//           <div className="bpd-selected">
//             <div className="bpd-overlap-group1">
//               <div className="bpd-rectangle-61"></div>
//               <Link to="/blog">
//               <div className="bpd-text-56 bpd-valign-text-middle bpd-overpass-bold-shark-14px">{text127}</div>
//               </Link>
//             </div>
//           </div>
//           <Link to="/faq">
//           <div className="bpd-unselected-i2601273-5 bpd-valign-text-middle bpd-typography-body-smalltext-14-regular">
//             {unselectedI26012736}
//           </div>
//           </Link>
//           <Link to="/contactus">
//           <div className="bpd-unselected-i2601273-6 bpd-valign-text-middle bpd-typography-body-smalltext-14-regular">
//             {unselectedI26012737}
//           </div>
//           </Link>
//         </div>
//         <GetAQuoteButton222>{getAQuoteButton22Props.children}</GetAQuoteButton222>
//       </div>
//     </div>
//   );
// }


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="bpd-group-86">
      <White src={whiteProps.src} />
      <img className="bpd-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="bpd-white">
      <img className="bpd-vector-1" src={src} />
    </div>
  );
}


function GetAQuoteButton222(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(i2601273864120TimelineData);
  }, []);

  return (
    <div className="bpd-i26012738-64120 bpd-component bpd-component-wrapper not-ready">
      <div className="bpd-master-button-Oalteb">
        <div className="bpd-button-i2601273864-MdU6bA bpd-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const i2601273864120TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".bpd-i26012738-64120",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function Footer32(props) {
//   const { group32Props, frame5Props, frame6Props, frame7Props } = props;

//   return (
//     <div className="bpd-footer">
//       <div className="bpd-frame-1585">
//         <Frame1578
//           overlapGroup1={group32Props.overlapGroup1}
//           vector2={group32Props.vector2}
//           group86222Props={group32Props.group86222Props}
//           facebookAppSymbol3Props={group32Props.facebookAppSymbol3Props}
//           twitter3Props={group32Props.twitter3Props}
//         />
//         <Frame53 text40={frame5Props.text40} frame4Props={frame5Props.frame4Props} />
//         <Frame6
//           text48={frame6Props.text48}
//           frame42Props={frame6Props.frame42Props}
//           frame422Props={frame6Props.frame422Props}
//         />
//       </div>
//       <Frame7 text56={frame7Props.text56} frame4Props={frame7Props.frame4Props} />
//     </div>
//   );
// }


function Frame1578(props) {
  const { overlapGroup1, vector2, group86222Props, facebookAppSymbol3Props, twitter3Props } = props;

  return (
    <div className="bpd-frame-1578">
      <Group86222 group85={group86222Props.group85} whiteProps={group86222Props.whiteProps} />
      <div className="bpd-frame-1584">
        <Group324 />
        <div className="bpd-frame-1583">
          <FacebookAppSymbol3 src={facebookAppSymbol3Props.src} />
          <div className="bpd-instagram">
            <div className="bpd-overlap-group1-1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
              <img
                className="bpd-vector-2"
                src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-100@2x.svg"
              />
              <img className="bpd-vector-3" src={vector2} />
            </div>
          </div>
          <Twitter3 src={twitter3Props.src} />
        </div>
      </div>
    </div>
  );
}


function Group86222(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="bpd-group-86-1">
      <White src={whiteProps.src} />
      <img className="bpd-group-85-1" src={group85} />
    </div>
  );
}


function Group324() {
  return (
    <div className="bpd-group-32">
      <div className="bpd-group-189">
        <div className="bpd-map-pin-1">
          <div className="bpd-overlap-group1-2">
            <img
              className="bpd-vector-4"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-90@2x.svg"
            />
          </div>
        </div>
        <p className="bpd-text-29 bpd-typographybody16-regular">
          #8, 105, Vishal Park Word, 3rd Cross, Cambridge Road Ulsoor, Bangalore, Bengaluru, Karnataka 560008
        </p>
      </div>
      <div className="bpd-group-18">
        <div className="bpd-phone">
          <img
            className="bpd-vector-5"
            src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-102@2x.svg"
          />
        </div>
        <div className="bpd-text-3 bpd-valign-text-middle bpd-typographybody16-regular">+91 8976535221, +91 8755645342</div>
      </div>
      <div className="bpd-group-18">
        <div className="bpd-mail">
          <div className="bpd-overlap-group1-3">
            <img
              className="bpd-vector-6"
              src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg"
            />
          </div>
        </div>
        <div className="bpd-text-3 bpd-valign-text-middle bpd-typographybody16-regular">contact@webuild.com</div>
      </div>
    </div>
  );
}


function FacebookAppSymbol3(props) {
  const { src } = props;

  return (
    <div className="bpd-facebook-app-symbol">
      <img className="bpd-f-1" src={src} />
    </div>
  );
}


function Twitter3(props) {
  const { src } = props;

  return (
    <div className="bpd-twitter">
      <img className="bpd-vector-7" src={src} />
    </div>
  );
}


function Frame53(props) {
  const { text40, frame4Props } = props;

  return (
    <div className="bpd-frame-5">
      <div className="bpd-text-32 bpd-valign-text-middle bpd-typographyheadlineh5-extrabold-20">{text40}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}


function Frame4(props) {
  const { text41, text42, text43, text44, text45, text46, text47 } = props;

  return (
    <div className="bpd-frame-4">
      <div className="bpd-text-4 bpd-valign-text-middle bpd-typographybody16-regular">{text41}</div>
      <div className="bpd-text-5 bpd-valign-text-middle bpd-typographybody16-regular">{text42}</div>
      <div className="bpd-text-5 bpd-valign-text-middle bpd-typographybody16-regular">{text43}</div>
      <div className="bpd-text-5 bpd-valign-text-middle bpd-typographybody16-regular">{text44}</div>
      <div className="bpd-text-5 bpd-valign-text-middle bpd-typographybody16-regular">{text45}</div>
      <div className="bpd-text-5 bpd-valign-text-middle bpd-typographybody16-regular">{text46}</div>
      <div className="bpd-text-5 bpd-valign-text-middle bpd-typographybody16-regular">{text47}</div>
    </div>
  );
}


function Frame6(props) {
  const { text48, frame42Props, frame422Props } = props;

  return (
    <div className="bpd-frame-6">
      <div className="bpd-text-40 bpd-valign-text-middle bpd-typographyheadlineh5-extrabold-20">{text48}</div>
      <div className="bpd-frame-1577">
        <Frame42
          text49={frame42Props.text49}
          text50={frame42Props.text50}
          place={frame42Props.place}
          text51={frame42Props.text51}
          text52={frame42Props.text52}
        />
        <Frame42
          text49={frame422Props.text49}
          text50={frame422Props.text50}
          place={frame422Props.place}
          text51={frame422Props.text51}
          text52={frame422Props.text52}
          className={frame422Props.className}
        />
      </div>
    </div>
  );
}


function Frame42(props) {
  const { text49, text50, place, text51, text52, className } = props;

  return (
    <div className={`bpd-frame-4-1 ${className || ""}`}>
      <div className="bpd-text-41 bpd-valign-text-middle bpd-overpass-extra-bold-white-16px">{text49}</div>
      <div className="bpd-frame-1580">
        <div className="bpd-text-4-1 bpd-valign-text-middle bpd-typographybody16-regular">{text50}</div>
        <div className="bpd-place bpd-valign-text-middle bpd-typographybody16-regular">{place}</div>
        <div className="bpd-text-43 bpd-valign-text-middle bpd-typographybody16-regular">{text51}</div>
        <div className="bpd-text-44 bpd-valign-text-middle bpd-typographybody16-regular">{text52}</div>
      </div>
    </div>
  );
}


function Frame7(props) {
  const { text56, frame4Props } = props;

  return (
    <div className="bpd-frame-7">
      <div className="bpd-text-48 bpd-valign-text-middle bpd-typographyheadlineh5-extrabold-20">{text56}</div>
      <Frame4
        text41={frame4Props.text41}
        text42={frame4Props.text42}
        text43={frame4Props.text43}
        text44={frame4Props.text44}
        text45={frame4Props.text45}
        text46={frame4Props.text46}
        text47={frame4Props.text47}
      />
    </div>
  );
}

const plusData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame1587Data = {
    text3: "Read More",
    plusProps: plusData,
    url:"/blogdetails",
};

const blogCardData = {
    frame1587Props: frame1587Data,
};

const plus2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15872Data = {
    text3: "Read More",
    plusProps: plus2Data,
    url:"/blogdetails",
};

const blogCard2Data = {
    frame1587Props: frame15872Data,
};

const plus3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15873Data = {
    text3: "Read More",
    plusProps: plus3Data,
    url:"/blogdetails"
};

const blogCard3Data = {
    frame1587Props: frame15873Data,
};

const plus4Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15874Data = {
    text3: "Read More",
    plusProps: plus4Data,
    url:"/blogdetails"
};

const blogCard4Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-10@2x.png",
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "bpd-blog-card",
    frame1587Props: frame15874Data,
};

const plus5Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15875Data = {
    text3: "Read More",
    plusProps: plus5Data,
    url:"/blogdetails"
};

const blogCard5Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-13@2x.png",
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "bpd-blog-card-1",
    frame1587Props: frame15875Data,
};

const plus6Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15876Data = {
    text3: "Read More",
    plusProps: plus6Data,
    url:"/blogdetails"
};

const blogCard6Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-16@2x.png",
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "bpd-blog-card-1",
    frame1587Props: frame15876Data,
};

const frame1641Data = {
    blogCardProps: blogCard4Data,
    blogCard2Props: blogCard5Data,
    blogCard3Props: blogCard6Data,
};

const plus7Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15877Data = {
    text3: "Read More",
    plusProps: plus7Data,
    url:"/blogdetails"
};

const blogCard7Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-11@2x.png",
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "bpd-blog-card",
    frame1587Props: frame15877Data,
};

const plus8Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15878Data = {
    text3: "Read More",
    plusProps: plus8Data,
    url:"/blogdetails"
};

const blogCard8Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-14@2x.png",
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "bpd-blog-card-1",
    frame1587Props: frame15878Data,
};

const plus9Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-174@2x.svg",
};

const frame15879Data = {
    text3: "Read More",
    plusProps: plus9Data,
    url:"/blogdetails"
};

const blogCard9Data = {
    blogThumbnail: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-83-17@2x.png",
    address: "5 June 2021",
    text1: "Lorem Ipsum passages of Lorem Ipsum available",
    text2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer quis sapien ac massa dapibus lacinia. Nunc et cursus quam. Cras pharetra condimentum leo,…",
    className: "bpd-blog-card-1",
    frame1587Props: frame15879Data,
};

const frame16412Data = {
    blogCardProps: blogCard7Data,
    blogCard2Props: blogCard8Data,
    blogCard3Props: blogCard9Data,
};

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: whiteData,
};

const getAQuoteButton222Data = {
    children: "GET A QUOTE",
};

// const headerWithBackground22Data = {
//     unselectedI2601273: "HOME",
//     unselectedI26012732: "ABOUT US",
//     unselectedI26012733: "PROJECTS",
//     unselectedI26012734: "VIDEOS",
//     unselectedI26012735: "INSIGHTS",
//     text127: "BLOGS",
//     unselectedI26012736: "FAQ’S",
//     unselectedI26012737: "CONTACT US",
//     group86Props: group86Data,
//     getAQuoteButton22Props: getAQuoteButton222Data,
// };

const white2Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
};

const group86222Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
    whiteProps: white2Data,
};

const facebookAppSymbol3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-2@2x.svg",
};

const twitter3Data = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-102@2x.svg",
};

const frame1578Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-99@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-96@2x.svg",
    group86222Props: group86222Data,
    facebookAppSymbol3Props: facebookAppSymbol3Data,
    twitter3Props: twitter3Data,
};

const frame4Data = {
    text41: "About Us",
    text42: "Projects",
    text43: "Videos",
    text44: "Packages",
    text45: "Insights",
    text46: "Blogs",
    text47: "FAQ’s",
};

const frame53Data = {
    text40: "Quick Links",
    frame4Props: frame4Data,
};

const frame42Data = {
    text49: "Construction",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
};

const frame422Data = {
    text49: "Interior",
    text50: "Basic",
    place: "Standard",
    text51: "Premium",
    text52: "Luxury",
    className: "bpd-frame-5-1",
};

const frame6Data = {
    text48: "Packages",
    frame42Props: frame42Data,
    frame422Props: frame422Data,
};

const frame43Data = {
    text41: "BBEMP",
    text42: "BWSSB",
    text43: "BESCOM",
    text44: "Procedure",
    text45: "Vaastu",
    text46: "Bye Laws",
    text47: "Tips & Ideas",
};

const frame7Data = {
    text56: "Insights",
    frame4Props: frame43Data,
};

// const footer32Data = {
//     group32Props: frame1578Data,
//     frame5Props: frame53Data,
//     frame6Props: frame6Data,
//     frame7Props: frame7Data,
// };

